/*
 * @Description: 供应商主数据相关接口
 */
import { RootObject } from '@/model/rootObject'
import https, { downloadExcel } from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'
import {
  SupplierInfoModel, SupplierBankModel,
  SupplierListParamModel, SupplierPageParamModel, CreateSupplierModel, UpdateSupplierModel, SupplierPageModel
} from '@/model/master-data/supplierModel'
import networkConfig from '@/config/default/net.config'

const baseUrl = '/base/vendor'

export const excelSupplierFileUpload = () => {
  return networkConfig.host + baseUrl + '/import/excel'
}

export const createSupplier = (supplierInfo: CreateSupplierModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/add', Method.POST, supplierInfo, ContentType.json)
}

// export const deleteSupplier = (supplierId: number) => {
//   return https().request<RootObject<number>>(baseUrl + '/delete/' + supplierId, Method.POST, undefined, ContentType.json)
// }

export const updateSupplier = (supplierInfo: UpdateSupplierModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/update', Method.POST, supplierInfo, ContentType.json)
}

export const getSupplierById = (supplierId: number) => {
  return https()
    .request<RootObject<SupplierInfoModel>>(baseUrl + '/get/' + supplierId, Method.GET, undefined, ContentType.json)
}

export const getSupplierPageList = (params: SupplierPageParamModel) => {
  return https().request<RootObject<SupplierPageModel>>(baseUrl + '/list', Method.POST, params, ContentType.json)
}

export const getSupplierAllList = (params: SupplierListParamModel) => {
  return https().request<RootObject<SupplierInfoModel[]>>(baseUrl + '/list/all', Method.POST, params, ContentType.json)
}

export const exportSupplierTemplate = () => {
  return downloadExcel(baseUrl + '/export/excelTemplate', Method.GET, undefined)
}

export const getByVendorNumber = (vendorNumber: string) => {
  return https()
    .request<RootObject<SupplierBankModel[]>>(baseUrl + '/get/bank/' + vendorNumber, Method.GET, undefined, ContentType.json)
}
